export default "__VITE_ASSET__BJplhEwF__"